import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sessionQueryKeys } from '@/entities/session';
import {
  type AdminAccMePasswordChangeData,
  endpoint,
  http,
  type PasswordChangeIn,
} from '@/shared/api';

const ENDPOINT = endpoint<AdminAccMePasswordChangeData>('/api/v1/admin/me/password');

/**
 * POST /api/v1/admin/me/password `{current_password, new_password}` → 204 (ТЗ ACC 4.8.3).
 * Ошибки 422: `wrong_current_password`, `weak_password`, `password_same` (поля формы).
 */
export async function changePassword(body: PasswordChangeIn): Promise<void> {
  await http.post(ENDPOINT, body);
}

/**
 * Ошибки показывает окно (плашка и поля), глобальный тост не нужен. После смены пароля профиль
 * перечитывается: `password_changed_at`, `password_is_temporary = false` (BR-ACC-05).
 */
export function useChangePassword() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: sessionQueryKeys.me }),
    meta: { errorToast: false },
  });
}
